import React from "react";
import styles from "./FeesModal.scss";
import close from "../../../../../../assets/images/close-icon.svg";

const FeesModal = props => (
  <div className={styles.modalcontainer}>
    <img
      src={close}
      className={styles.closebutton}
      onClick={() => props.onHide()}
    />
    <div className={styles.modalcontent}>
      <div className={styles.header}>
        <h2 className={styles.title}>Our Fees</h2>
      </div>
      <div className={styles.divider}>
        <div className={styles.top} />
        <div className={styles.bottom} />
      </div>
      <div className={styles.intro}>
        <p>
          Once the member completes your project, The Second Shift will send you
          an invoice for the project fee, plus a 15% service fee.
        </p>
        <p>
          Once we receive funds from you, we pay the member the project fee
          minus a 5% service fee.
        </p>
        <p>
          For example, for a $1,000 project, you will pay The Second Shift
          $1,150 ($1,000 Project Payment + $150 service fee) once the project is
          completed.
        </p>
        <p>
          Once we receive your payment, we will pay the member $950 ($1,000
          Project Payment - $50 service fee).
        </p>
        <p>
          If you do not send us payment at the agreed upon time based on the
          payment terms, we will charge your credit card for the amount due in
          full.
        </p>
      </div>
    </div>
  </div>
);

export default FeesModal;



// WEBPACK FOOTER //
// ./src/routes/employer/signUp/components/VerifyAccount/FeesModal/FeesModal.js